<ws-modal-wrapper headerLabel="Asset Classifications"
                  [hideFooter]="true"
                  (cancel)="cancel()">
    <div class="ws-picker-tree">
        @if (assetClassifications) {
            <ul>
                @for (topLevel of assetClassifications; track topLevel; let i = $index) {
                    <li>
                        <div [ngClass]="i % 2 ? 'tree-line-holder-odd' : 'tree-line-holder-even'">
                            @if (!isExpanded(topLevel)) {
                                <span class="node-collapsed"
                                      [ngClass]="topLevel.childClassifications.length > 0 ? '' : 'empty-tree-node'"
                                      (click)="expandClass(topLevel)"></span>
                            } @else {
                                <span class="node-expanded"
                                      [ngClass]="topLevel.childClassifications.length > 0 ? '' : 'empty-tree-node'"
                                      (click)="collapseClass(topLevel)"></span>
                            }
                            <span class="entity-link"
                                  [ngClass]="isSelected(topLevel) ? 'active-entity-link' : ''"
                                  (click)="selectAssetClass(topLevel)"
                                  [title]="topLevel.name + (topLevel.allowPerpetual ? ' (Can be perpetual)' : '')">{{ topLevel.name }}</span>
                        </div>
                        @if (isExpanded(topLevel)) {
                            <ul [@pickerEnter]>
                                @for (secondLevel of topLevel.childClassifications; track secondLevel; let j = $index) {
                                    <li>
                                        <div class="tree-line-level-2"
                                             [ngClass]="(i + j + 1) % 2 ? 'tree-line-holder-odd' : 'tree-line-holder-even'">
                                            @if (!isExpanded(secondLevel)) {
                                                <span class="node-collapsed"
                                                      [ngClass]="secondLevel.childClassifications.length > 0 ? '' : 'empty-tree-node'"
                                                      (click)="expandClass(secondLevel)"></span>
                                            } @else {
                                                <span class="node-expanded"
                                                      [ngClass]="secondLevel.childClassifications.length > 0 ? '' : 'empty-tree-node'"
                                                      (click)="collapseClass(secondLevel)"></span>
                                            }
                                            <span class="entity-link"
                                                  [ngClass]="isSelected(secondLevel) ? 'active-entity-link' : ''"
                                                  (click)="selectAssetClass(secondLevel)"
                                                  [title]="secondLevel.name + (secondLevel.allowPerpetual ? ' (Can be perpetual)' : '')">{{ secondLevel.name }}</span>
                                        </div>
                                        @if (isExpanded(secondLevel)) {
                                            <ul [@pickerEnter]>
                                                @for (
                                                    thirdLevel of secondLevel.childClassifications; track thirdLevel; let
                                                    k = $index) {
                                                    <li>
                                                        <div class="tree-line-level-3"
                                                             [ngClass]="(i + j + k) % 2 ? 'tree-line-holder-odd' : 'tree-line-holder-even'">
                                                            <span class="entity-link"
                                                                  [ngClass]="isSelected(thirdLevel) ? 'active-entity-link' : ''"
                                                                  (click)="selectAssetClass(thirdLevel)"
                                                                  [title]="thirdLevel.name + (thirdLevel.allowPerpetual ? ' (Can be perpetual)' : '')">{{ thirdLevel.name }}</span>
                                                        </div>
                                                    </li>
                                                }
                                            </ul>
                                        }
                                    </li>
                                }
                            </ul>
                        }
                    </li>
                }
            </ul>
        }
    </div>
</ws-modal-wrapper>
